import { render } from "./Boats.vue?vue&type=template&id=4283fe94&scoped=true"
import script from "./Boats.vue?vue&type=script&lang=js"
export * from "./Boats.vue?vue&type=script&lang=js"

import "./Boats.vue?vue&type=style&index=0&id=4283fe94&scoped=true&lang=scss"
import "./Boats.vue?vue&type=style&index=1&id=4283fe94&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4283fe94"]])

export default __exports__